//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: {
            required: true,
            type: String,
            default: ""
        },
        isReadOnly: {
            required: false,
            type: Boolean,
            default: false
        },
        group: {
            required: false,
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            condition: {},
            logicOperators: {
                "&&": "AND",
                "||": "OR"
            }
        };
    },
    watch: {
        value: {
            handler(v) {
                this.condition = v;
            },
            immediate: true
        },
        condition: {
            handler(v) {
                this.$emit("input", v);
            },
            deep: true
        }
    }
};
